// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3ZjAC","btn":"styles_btn__2Fl5b","wrapper":"styles_wrapper__JoRe6","mb":"styles_mb__3TQHm","mb8":"styles_mb8__2WA_u","tip":"styles_tip__236xc"};